export enum Entries {
    Five = 5,
    Ten = 10,
    Twenty = 20
}